export default async function getRecaptchaToken(vm, action = 'login') {
  if (
    Number(process.env.VUE_APP_DISABLE_RECAPTCHA) === 1
    || Number(process.env.DISABLE_RECAPTCHA) === 1
  ) {
    return 'TEST';
  }
  await vm.$recaptchaLoaded();
  return vm.$recaptcha(action);
}
